import { Component, Input, OnChanges } from '@angular/core';
import { RichToolTipComponent } from 'src/app/shared/components/rich-tooltip.component';
import { FacilityVaccinationStatus } from 'src/app/shared/models/facility-vaccination-status.model';

@Component({
    selector: 'nova-vaccine-preview',
    templateUrl: './vaccine-preview.component.html',
    styleUrls: ['./vaccine-preview.component.scss'],
    standalone: true,
    imports: [RichToolTipComponent]
})
export class VaccinePreviewComponent implements OnChanges {
    defaultPreview = [
        {
            vaccinationTypeName: 'COV',
            vaccinationTypeDescription: 'COVID-19 Vaccine (Facility Guideline)',
            vaccinationStatusName: 'Unknown',
            vaccinationStatusDescription: 'Unknown'
        },
        {
            vaccinationTypeName: 'FLU',
            vaccinationTypeDescription: 'Flu Vaccine (Facility Guideline)',
            vaccinationStatusName: 'Unknown',
            vaccinationStatusDescription: 'Unknown'
        }
    ] as FacilityVaccinationStatus[];

    @Input()
    data: FacilityVaccinationStatus[] = this.defaultPreview;

    ngOnChanges(): void {
        if (this.data?.length === 0) {
            this.data = this.defaultPreview;
        }
    }
}
